<template>
  <div class="dr-picker" v-if="isOpen" :class="['mode-' + (tmpMode || mode)]">
    <div style="display: flex;justify-content: space-between;background: #910a0a;padding: 15px;margin: -15px -15px 15px;">
      <div style="display: flex; gap: 15px;">
        <input type="text"
               placeholder="Von"
               :value="startOfRangeFormatted"
               name="range-start"
               class="range-input"
               readonly="readonly"
               inputmode='none'
               @click="mode='range-start'"
               ref="range-start"
        />
        <input type="text"
               placeholder="Bis"
               :value="endOfRangeFormatted"
               name="range-end"
               class="range-input"
               readonly="readonly"
               inputmode='none'
               @click="mode='range-end'"
               ref="range-end"
        />
      </div>
      <button type="button" class="close-filter" @click="hide()"><span class="sr-only">Close</span></button>
    </div>
    <div style="display: flex; justify-content: space-between; margin: 0 -5px;" class="month-overview">
      <button
          v-for="month in monthsOverview"
          :key="month.date.getTime()"
          type="button"
          class="month"
          :class="{'is-current': compareDate(month.date, currentMonth) === 0}"
          @click="gotoMonth(month.date)">{{ month.formatted }}</button>
    </div>
    <div style="display: flex; gap: 15px; width: 100%; flex-wrap: wrap;" class="inner">
      <button type="button" class="prev-month" @click="prevMonth()"><span class="sr-only">Previous month</span></button>
      <div
          class="dr-picker-calendars"
          @mouseleave="reset()">
        <Calendar
            :month="months[0]"
            :date_classes="dateClasses"
            :min_date="today"
            @hover:date="dateHover($event)"
            @click:date="dateSelect($event)"
        />
        <Calendar
            :month="months[1]"
            :date_classes="dateClasses"
            :min_date="today"
            @hover:date="dateHover($event)"
            @click:date="dateSelect($event)"
        />
      </div>
      <button type="button" class="next-month" @click="nextMonth()"><span class="sr-only">Next month</span></button>
    </div>
  </div>
</template>

<script>
import Calendar from "./components/Calendar";
import { toDate, startOfDay, startOfMonth, addMonths, format, parse, isValid } from 'date-fns';
import { de } from 'date-fns/locale';
 let ID = 0;
export default {
  name: "DrPicker",
  components: {Calendar},
  props: {
    dateFromEl: HTMLElement,
    dateToEl: HTMLElement,
    overlayEl: HTMLElement
  },
  data: () => {
    return {
      ID: 0,
      mode: 'range-start',
      tmpMode: null,
      isOpen: false,
      overlay: null,
      today: startOfDay(new Date()),
      currentMonth: startOfMonth(new Date()),
      tmpDate: null,
      startOfRange: null,
      tmpStartOfRange: null,
      endOfRange: null,
      tmpEndOfRange: null,
      range: []
    }
  },
  computed: {
    startOfRangeFormatted() {
      let startOfRange = this.tmpStartOfRange || this.startOfRange;
      if (!startOfRange) {
        return '';
      }

      return this.formatDate(startOfRange);
    },
    endOfRangeFormatted() {
      let endOfRange = this.tmpEndOfRange || this.endOfRange;
      if (!endOfRange) {
        return '';
      }

      return this.formatDate(endOfRange);
    },

    months() {
      const currentMonth = toDate(this.currentMonth);
      return [currentMonth, addMonths(currentMonth, 1)]
    },

    monthsOverview() {
      const monthCount = 7;
      const currentMonth = toDate(this.currentMonth);
      const thisMonth = startOfMonth(new Date());
      let startOfRange = addMonths(currentMonth, -Math.floor(monthCount / 2));
      if (this.compareDate(startOfRange, thisMonth) < 0) {
        startOfRange = thisMonth;
      }
      const overview = [];
      for (let i = 0; i < monthCount; i++) {
        const date = addMonths( startOfRange, i );
        const formatted = format( date, 'MMM yy', { locale: de });
        overview.push({ date, formatted });
      }

      return overview;
    }
  },

  methods: {

    compareDate(a, b) {
      return Math.floor(a.getTime() / 86400000) - Math.floor(b.getTime() / 86400000);
    },

    formatDate(date) {
      return isValid(date) ? format(date, 'd.M.yyyy') : '';
    },

    parseDate(value) {
      try {
        const date = parse(value, 'd.M.yyyy', startOfDay(new Date()));
        if (!isValid(date)) {
          return null;
        }

        return date;
      } catch (err) {
        return null;
      }
    },

    reset() {
      this.tmpDate = null;
      this.tmpStartOfRange = null;
      this.tmpEndOfRange = null;
    },

    prevMonth() {
      this.currentMonth = addMonths(this.currentMonth, -1);
    },

    gotoMonth(date) {
      this.currentMonth = startOfMonth(date);
    },

    nextMonth() {
      this.currentMonth = addMonths(this.currentMonth, +1);
    },

    dateSelect(day) {
      let startOfRange = this.startOfRange;
      let endOfRange = this.endOfRange;
      let mode = this.mode;
      if (mode === 'range-start') {
        startOfRange = day;
        if (!endOfRange || endOfRange.getTime() < day.getTime()) {
          endOfRange = day;
        }
      } else {
        if (startOfRange && day.getTime() < startOfRange.getTime()) {
          startOfRange = day;
          mode = 'range-start';
        }
        endOfRange = day;
      }
      if (mode === 'range-end') {
        this.$emit('update:range', { start: startOfRange, end: endOfRange });
        this.hide();
      } else {
        mode = 'range-end';
      }
      this.mode = mode;
      this.tmpMode = mode;
      this.startOfRange = startOfRange;
      this.tmpStartOfRange = startOfRange;
      this.endOfRange = endOfRange;
      this.tmpEndOfRange = endOfRange;

    },

    dateHover(day) {
      this.tmpDate = day;
      let tmpStartOfRange = this.startOfRange;
      let tmpEndOfRange = this.endOfRange;
      this.tmpMode = this.mode;
      if (this.mode === 'range-start') {
        tmpStartOfRange = day;
        if (tmpEndOfRange && tmpEndOfRange.getTime() < day.getTime()) {
          tmpEndOfRange = day;
        }
      } else {
        if (tmpStartOfRange && day.getTime() < tmpStartOfRange.getTime()) {
          tmpStartOfRange = day;
          this.tmpMode = 'range-start';
        }
        tmpEndOfRange = day;
      }
      this.$refs[this.tmpMode].focus();
      this.tmpStartOfRange = tmpStartOfRange;
      this.tmpEndOfRange = tmpEndOfRange;
    },

    dateClasses(day) {
      const classes = [];
      if (this.today.getTime() === day.getTime()) {
        classes.push('today');
      }
      if (this.startOfRange && day.getTime() === this.startOfRange.getTime()) {
        classes.push('start-of-range');
      }
      if (this.endOfRange && day.getTime() === this.endOfRange.getTime()) {
        classes.push('end-of-range');
      }
      if (this.tmpDate && this.tmpDate.getTime() === day.getTime()) {
        classes.push('hover');
      }
      if (
          this.startOfRange && this.endOfRange
          && this.startOfRange.getTime() <= day.getTime()
          && day.getTime() <= this.endOfRange.getTime()
      ) {
        classes.push('in-range');
      }

      return classes;
    },

    show(settings) {
      console.log('OPEN');
      this.mode = settings.mode || 'range-start';
      this.tmpMode = this.mode;
      this.startOfRange = (settings.range && settings.range.start) || this.today;
      this.tmpStartOfRange = this.startOfRange;
      this.gotoMonth(this.startOfRange);
      this.endOfRange = (settings.range && settings.range.end) || this.today;
      this.tmpEndOfRange = this.endOfRange;

      if (this.isOpen) {
        return;
      }
      const overlayWrapper = document.body;
      window.document.getElementsByTagName('HTML')[0].classList.add('dr-picker-opened');
      this.overlay = window.document.createElement('DIV');
      this.overlay.classList.add('dr-picker-overlay');
      this.overlay.addEventListener('click', () => {
        this.hide();
      });
      overlayWrapper.appendChild(this.overlay);
      this.isOpen = true;
    },

    hide() {
      console.log('hide');
      if (!this.isOpen) {
        return;
      }
      this.isOpen = false;
      this.overlay.remove();
      this.overlay = null;
      window.document.getElementsByTagName('HTML')[0].classList.remove('dr-picker-opened');
    }

  },

  created() {
    this.ID = ++ID;
  }

}
</script>

<style lang="scss">

/*.dr-picker-opened {*/
/*  overflow: hidden;*/
/*}*/

button.month {
  padding: 5px;
  background-color: #fff;
  color: #EA7819;
  border-color: #EA7819;
  border: 1px solid;
  flex-grow: 1;
  margin: 5px;

  &.is-current {
    background: #910A0A;
    color: #fff;
  }
}

@media (hover: hover) {
  button.month:hover {
    background-color: #EA7819;
    color: #fff;
  }
}

.range-input {
  width: 100px;
}
 .dr-picker-overlay {
   background-color: transparent;
   position: fixed;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   z-index: 99998;
 }

.mode-range-start input[name="range-start"] {
  background: #ea7819;
  color: #fff;
}
.mode-range-end input[name="range-end"] {
  background: #ea7819;
  color: #fff;
}

.dr-picker-calendars {
  display: flex;
  gap: 15px;
}
  .dr-picker {
    position: absolute;
    left: -15px;
    top: -15px;
    z-index: 99999;
    background: rgb(255, 255, 255);
    border: 1px solid #910a0a;
    box-shadow: 0px 0px 5px #00000099;
    padding: 15px;
    min-width: 680px;
  }
  .dr-picker-calendars {

  }
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0,0,0,0);
    border: 0;
  }
  .prev-month {
    border-radius: 50%;
    height: 48px;
    width: 48px;
    padding: 0;
    line-height: 48px;
    display: block;
    box-sizing: border-box;
    align-self: center;
    flex: 0 0 auto;
  }
  .prev-month::before {
    content: '\e87e';
    display: inline-block;
    vertical-align: middle;
    font-family: eicons;
    font-size: 28px;
    text-align: center;
    color: #fff;
    font-weight: 400;
    font-style: normal;
    font-variant: normal;
    line-height: 1;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .next-month {
    border-radius: 50%;
    height: 48px;
    width: 48px;
    padding: 0;
    line-height: 48px;
    display: block;
    box-sizing: border-box;
    align-self: center;
    flex: 0 0 auto;
  }
  .next-month::before {
    content: '\e87d';
    display: inline-block;
    vertical-align: middle;
    font-family: eicons;
    font-size: 28px;
    text-align: center;
    color: #fff;
    font-weight: 400;
    font-style: normal;
    font-variant: normal;
    line-height: 1;
    text-rendering: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .close-filter {
    justify-self: flex-end;
    flex: 0 1 auto;
    padding: 5px;
    align-self: center;
    border-radius: 50%;
  }
 .close-filter::before {
   content: '\e87f';
   display: inline-block;
   vertical-align: middle;
   font-family: eicons;
   font-size: 28px;
   text-align: center;
   color: #fff;
   font-weight: 400;
   font-style: normal;
   font-variant: normal;
   line-height: 1;
   text-rendering: auto;
   -webkit-font-smoothing: antialiased;
   -moz-osx-font-smoothing: grayscale;
 }

@media screen and (max-width: 576px) {
  .dr-picker {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin-left: 0px !important;
    margin-top: 0px !important;
    min-width: auto;

    .month-overview {
      position: absolute;
      top: 70px;
      left: 15px;
      right: 15px;
      height: 50px;
      margin : 0;
    }

    .dr-picker-calendars {
      overflow-y: auto;
      overflow-x: hidden;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 68px;
      padding-top: 5px;
      padding-bottom: 5px;
      flex-direction: column;
      flex-grow: 1;
    }
  }

  table.drp-calendar {
    tbody td.day span,
    tbody td span,
    tbody th span,
    td, th {
      height: 32px;
      line-height: 32px;
      font-size: 16px;
    }
  }

  .dr-picker-opened body {
    overflow-y: hidden;
  }

  .inner {
    display: flex;
    gap: 15px;
    width: 100%;
    position: absolute;
    left: 0;
    top: 120px;
    bottom: 0;
    padding-bottom: 83px;
    padding-top: 15px;
    overflow-y: auto;
  }

  .prev-month,
  .next-month {
    position: absolute;
    bottom: 0;
    border-radius: 0;
    width: 50%;
    border: 10px solid #fff;
    box-sizing: border-box;
    height: 68px;
    box-shadow: 0px -1px 0px 0px #910a0a;
  }

  .prev-month {
    left: 0;
  }

  .next-month {
    right: 0;
  }
}
</style>
